import { Injectable } from '@angular/core';
import { Step } from '@rtls/core/models/thing/step.model';
import { Thing } from '@rtls/core/models/thing/thing.model';

@Injectable()
export class ThingAnomaliesService {
	public getAnomalies(thing: Thing): Step[] {
		return thing.latestSteps.filter((s: Step) => {
			return (
				this.isValid(s) &&
				(this.isOutsideOfAreaOfOperation(s) ||
					this.isInRetention(s) ||
					this.isUnauthorizedMovement(s) ||
					this.isOutsideOwnerLocation(s))
			);
		});
	}

	private isOutsideOfAreaOfOperation(step: Step) {
		return step.story === 'area_of_operation' && step.state.key === 'outside';
	}

	private isInRetention(step: Step) {
		return step.story === 'retention' && (step.state.key === 'retention' || step.state.key === 'retention_outside');
	}

	private isUnauthorizedMovement(step: Step) {
		return step.story === 'unauthorized_movement' && step.state.key === 'unauthorized_movement';
	}

	private isOutsideOwnerLocation(step: Step) {
		return step.story === 'outside_owner_location' && step.state.key === 'outside_owner_location';
	}

	private isValid(step: Step): boolean {
		return !!step.storyKind && step.storyKind.key === 'BUSINESS' && !!step.storyTranslation;
	}
}
